import {
  Address,
  AddressDeliverabilityCorrectedAddress,
  PersonalInfoInput,
  VerifyDeliveryAddressQueryVariables,
} from 'generated/types'
import { getGeneralError } from 'utils/getGeneralError/getGeneralError'
import states from 'utils/states'

import { emptyAddress } from './constants'
import { FormattedAddress } from './types'

export const formattedAddress = (address: Address | FormattedAddress | null): FormattedAddress => {
  if (address) {
    return {
      street1: address.street1,
      street2: address.street2 || '',
      city: address.city,
      zipCode: address.zipCode,
      state: address.state,
    }
  }
  return { ...emptyAddress }
}

export const formattedCorrectedAddress = (
  correctedAddress: AddressDeliverabilityCorrectedAddress,
): FormattedAddress => {
  return {
    street1: correctedAddress.street1 ?? '',
    street2: correctedAddress.street2 ?? '',
    city: correctedAddress.city ?? '',
    zipCode: correctedAddress.zipCode ?? '',
    state: correctedAddress.state ?? '',
  }
}

export const toAddressDeliverabilityInput = (
  address: PersonalInfoInput,
): VerifyDeliveryAddressQueryVariables => {
  return {
    street1: address.address1,
    street2: address.address2,
    city: address.city,
    state: states.filter((state) => state.value === address.state)[0].label,
    zipCode: address.zip,
    country: 'US',
  }
}

export const displayServiceUnavailableModal = (closeErrorModal, onSubmit, showErrorModal) => {
  const { title, message, actions, image } = getGeneralError(
    'Service unavailable',
    { closeErrorModal },
    () => {
      closeErrorModal()
      onSubmit()
    },
    500,
  )
  showErrorModal({ title, message, actions, image })
}
